<template>
  <mdb-container class="bv-example-row wrapper" ref="requestboard">
    <mdb-row class="d-flex justify-content-center firstrow">
      <mdb-row class="d-flex justify-content-center boardsecondrow">
        <div class="um_box">
          <div class="inbox">
            <div class="ininbox">
              <div class="icon">
                <mdb-icon icon="car-side" class="white-text pr-3" size="3x"/>
              </div>
              <div class="tx">
                이달, 출고예약
                <em>
                  <span class="counter">{{ viewCount.monthlyOut }}</span>
                </em>
              </div>
            </div>
            <div class="ininbox">
              <div class="icon">
                <mdb-icon icon="address-book" class="white-text pr-3" size="3x"/>
              </div>
              <div class="tx">
                오늘, 신청고객
                <em>
                  <span class="counter">{{ viewCount.todayRequest }}</span>
                </em>
              </div>
            </div>
            <div class="ininbox">
              <div class="icon">
                <mdb-icon icon="address-card" class="white-text pr-3" size="3x"/>
              </div>
              <div class="tx">
                누적, 계약대수
                <em>
                  <span class="counter">{{ viewCount.totalCars }}</span>
                </em>
              </div>
            </div>
            <div class="ininbox">
              <div class="icon">
                <mdb-icon icon="clipboard-list" class="white-text pr-3" size="3x"/>
              </div>
              <div class="tx">
                누적, 신정건수
                <em>
                  <span class="counter">{{ viewCount.totalRequest }}</span>
                </em>
              </div>
            </div>
          </div>
        </div>
      </mdb-row>
    </mdb-row>
  </mdb-container>
</template>

<script scoped>
import { requestboard } from '@/api';

export default {
  name: 'TablePage',
  data() {
    return {
      realCount: {
        monthlyOut: 0,
        todayRequest: 0,
        totalCars: 0,
        totalRequest: 0,
      },
      viewCount: {
        monthlyOut: 0,
        todayRequest: 0,
        totalCars: 0,
        totalRequest: 0,
      },
    };
  },
  created() {
    this.findRequestboard();
  },
  methods: {
    findRequestboard() {
      requestboard.fetch()
        .then((data) => {
          this.realCount = data.data;
          this.viewCount = data.data;
        })
        .finally();
    },
    isElementViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0
        && rect.left >= 0
        && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  padding-right: 0px;
  padding-left: 0px;
  margin-right: 0px;
  margin-left: 0px;
  align-items: center;
}
.boardsecondrow {
  max-width: 1348px;
  max-height: 320px;
  background-color: #212121 !important;
  align-items: center;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0px;
  margin-left: 0px;
  background-color: #212121;
}
@media only all and (min-width: 301px) {
    .um_box {
        width: 100%;
        float: left;
        background-color: #212121;
        position: relative;
        z-index: 1;
    }
}
@media only all and (min-width: 301px) {
    .inbox {
        max-width: 1450px;
        margin: 0px auto;
        position: relative;
    }
}
@media only all and (min-width: 301px) {
    .um_box .inbox .ininbox {
        width: 25%;
        float: left;
        padding: 20px 3%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
@media only all and (min-width: 301px) {
    .um_box .inbox .ininbox .icon {
        width: 110px;
        height: 110px;
        border-radius: 110px;
        float: left;
        text-align: center;
        line-height: 110px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
img {
    display: inline-block;
    vertical-align: top;
    max-width: 100%;
    height: auto;
}
@media only all and (min-width: 301px) {
    .um_box .inbox .ininbox .tx {
        width: calc(100% - 100px);
        float: left;
        padding-left: 0px;
        font-size: 18px;
        color: #fff;
        font-weight: 600;
        box-sizing: border-box;
    }
}
@media only all and (min-width: 301px) {
    .um_box .inbox .ininbox .tx em {
        width: 100%;
        float: left;
        font-size: 90px;
        font-weight: 900;
        color: #ffba00;
        line-height: 60px;
    }
}
em {
    font-style: normal;
}
.counter {
    position: relative;
    left: auto;
    z-index: 2;
    margin-left: 0px;
    font-size: 21px;
    color: #ffba00;
    background-color: transparent;
    border-radius: 10em;
    -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
    font-size: 50px;
    font-weight: 900;
    line-height: 60px;
}
.pr-3, .px-3 {
    padding-right: 0rem!important;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left !important;
    color: #2c3e50;
}
</style>
